var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SessionStatusEnum, } from '@sgdf/client';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { withResizeObserver } from '../../internal/with-resize-observer';
import styles from './participant-list.styles';
import '../../atoms/table/sgdf-table.js';
import { iconByMode } from '../participant-card/participant-card.js';
import { SKELETON_PARTICIPANT } from '../participant.utils';
import { SgdfElement } from '../../internal/sgdf-element';
import '../../atoms/table-next/table-next.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import { genderHelperFontAwesome, genderHelper, } from '../../helpers/genderHelper';
const getStyle = (status) => `--icon-color: var(--sgdf-color-${status}-600); --icon-size:1.3rem;`;
function getAge(date) {
    return Math.floor(Math.abs(Date.now() - date.getTime()) / 31557600000);
}
const ddcsRegex = new RegExp('^[0-9]{5,}-[a-zA-Z]{4}$');
function ddcsFormatter(numero) {
    if (ddcsRegex.test(numero)) {
        return numero;
    }
    return html `<span class="invalid" style="color: red">${numero}</span>`;
}
class SgdfParticipantList extends withResizeObserver(SgdfElement) {
    constructor() {
        super(...arguments);
        this.skeleton = false;
        this.mode = 'link';
        this.currentId = null;
        this.columns = [
            {
                id: 'actions',
                enableColumnFilter: false,
                enableSorting: false,
                header: () => 'Actions',
                cell: info => {
                    var _a;
                    const participant = info.row.original;
                    return html `
                    <div class="actions">
                        <sl-tooltip content="Observation">
                            <sgdf-icon-button
                                name=${iconByMode.link}
                                style=${getStyle('neutral')}
                                @click=${(e) => {
                        e.preventDefault();
                        this.emit('sgdf-participant:navigate', {
                            detail: {
                                participantId: participant.id,
                                action: 'link',
                            },
                        });
                    }}
                            >
                            </sgdf-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Détail du participant">
                            <sgdf-icon-button
                                name=${iconByMode.detail}
                                style=${((_a = participant === null || participant === void 0 ? void 0 : participant.usage_first_name) !== null && _a !== void 0 ? _a : participant.first_name)
                        ? getStyle('neutral')
                        : getStyle('warning')}
                                @click=${(e) => {
                        e.preventDefault();
                        this.emit('sgdf-participant:navigate', {
                            detail: {
                                participantId: participant.id,
                                action: 'detail',
                            },
                        });
                    }}
                            >
                            </sgdf-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Émargement & Photo">
                            <sgdf-icon-button
                                name=${iconByMode['check-in']}
                                style=${getStyle(participant.signature_available
                        ? 'success'
                        : 'neutral')}
                                @click=${(e) => {
                        e.preventDefault();
                        this.emit('sgdf-participant:navigate', {
                            detail: {
                                participantId: participant.id,
                                action: 'check-in',
                            },
                        });
                    }}
                            >
                            </sgdf-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Rédaction de l'avis">
                            <sgdf-icon-button
                                name=${iconByMode.validation}
                                style=${getStyle(participant.session_status ===
                        SessionStatusEnum._1
                        ? 'neutral'
                        : 'success')}
                                @click=${(e) => {
                        e.preventDefault();
                        this.emit('sgdf-participant:navigate', {
                            detail: {
                                participantId: participant.id,
                                action: 'validation',
                            },
                        });
                    }}
                            >
                            </sgdf-icon-button>
                        </sl-tooltip>
                    </div>
                `;
                },
            },
            {
                id: 'first_name',
                accessorFn: row => { var _a; return (_a = row.usage_first_name) !== null && _a !== void 0 ? _a : row.first_name; },
                header: () => 'Prénom',
                cell: info => info.getValue(),
            },
            {
                id: 'last_name',
                accessorFn: row => { var _a; return (_a = row.usage_last_name) !== null && _a !== void 0 ? _a : row.last_name; },
                header: () => 'Nom',
                cell: info => info.getValue(),
            },
            {
                accessorKey: 'fonction',
                header: () => 'Fonction',
                cell: info => info.getValue(),
            },
            {
                id: 'structure_principale',
                accessorFn: participant => { var _a; return (_a = participant.structure_principale) === null || _a === void 0 ? void 0 : _a.label; },
                header: () => 'Structure',
                cell: info => info.getValue(),
            },
            {
                accessorFn: participant => participant.age_at_meeting_start == 0
                    ? participant.user.birthdate
                        ? getAge(participant.user.birthdate)
                        : undefined
                    : participant.age_at_meeting_start,
                id: 'age',
                header: () => 'Age',
                cell: info => info.getValue(),
                enableColumnFilter: false,
            },
            {
                accessorFn: participant => participant.user.gender
                    ? genderHelper.format(participant.user.gender)
                    : undefined,
                id: 'gender',
                header: () => 'Genre',
                cell: info => {
                    const participant = info.row.original;
                    return participant.user.gender
                        ? html `<sgdf-icon
                          name=${genderHelperFontAwesome.format(participant.user.gender)}
                      >
                      </sgdf-icon>`
                        : undefined;
                },
                enableColumnFilter: false,
            },
            {
                accessorFn: participant => participant.num_bafa_bafd,
                id: 'num_bafa_bafd',
                header: () => 'Num. BAFA/BAFD',
                cell: info => ddcsFormatter(info.getValue()),
                enableColumnFilter: false,
            },
        ];
    }
    onResize({ width }) {
        this._width = width;
    }
    onTableClick(event) {
        event.stopPropagation();
        this.emit('sgdf-participant:navigate', {
            detail: {
                participantId: event.detail.id,
                action: this.mode,
            },
        });
    }
    onSortChange(e) {
        this.emit('sgdf-participants-sort:change', {
            detail: {
                sortField: e.target.value,
            },
        });
    }
    onSortDirChange() {
        this.emit('sgdf-participants-sort-dir:change', {});
    }
    render() {
        // NOTE: This value is arbitrary, we don't have a better solution for now
        // It's a bit more than the width of the table in french (which is the largest) and with both links (download and pay)
        // The table width is mostly stable since the with of the amount is fixed and the rest is almost always the same number of characters
        const bigMode = this._width && this._width > 700;
        const skeleton = this.skeleton || this.participants == null;
        const participants = skeleton
            ? SKELETON_PARTICIPANT
            : this.participants;
        return bigMode
            ? this._renderBig(participants)
            : this._renderSmall(skeleton, participants);
    }
    _renderBig(participants) {
        return html `<sgdf-table-next
            .columns=${this.columns}
            .data=${participants}
            no-pagination
        ></sgdf-table-next>`;
    }
    _renderSmall(skeleton, participants) {
        return html `
            <div class="sort-line">
                <sl-select
                    @sl-change=${(e) => {
            this.onSortChange(e);
        }}
                    value="${this.sortField}"
                >
                    <sgdf-icon
                        name="${this.sortField == 'shuffle'
            ? 'shuffle'
            : this.isSortAsc === 'true'
                ? 'arrow-down-a-z'
                : 'arrow-up-a-z'}"
                        slot="prefix"
                    ></sgdf-icon>
                    <sl-option value="firstname">Prénom</sl-option>
                    <sl-option value="lastname">Nom</sl-option>
                    <sl-option value="dailytaskteam"
                        >Équipe de service</sl-option
                    >
                    <sl-option value="nobservations"
                        >Nb. d'observations</sl-option
                    >
                    <sl-option value="branche">Branche</sl-option>
                    <sl-option value="shuffle">Mélanger</sl-option>
                </sl-select>
                <sl-tooltip content="Changer l'ordre de tri / Mélanger">
                    <sgdf-icon-button
                        name="${this.sortField == 'shuffle'
            ? 'shuffle'
            : 'arrow-right-arrow-left'}"
                        class="${this.sortField != 'shuffle'
            ? 'arrow-rotate'
            : ''}"
                        @click=${() => this.onSortDirChange()}
                    >
                    </sgdf-icon-button>
                </sl-tooltip>
            </div>
            <div class="participant-list">
                ${map(participants, participant => html `
                        <sgdf-participant-card
                            .mode=${this.mode}
                            .participant=${participant}
                            .skeleton=${skeleton}
                            .highlight=${this.currentId === participant.id}
                        ></sgdf-participant-card>
                    `)}
            </div>
        `;
    }
}
SgdfParticipantList.styles = styles;
export default SgdfParticipantList;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantList.prototype, "skeleton", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfParticipantList.prototype, "participants", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "mode", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "currentId", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "sortField", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "isSortAsc", void 0);
//# sourceMappingURL=participant-list.component.js.map